import { render, staticRenderFns } from "./SorteosParam.vue?vue&type=template&id=61085e3a&scoped=true&dark=true"
import script from "./SorteosParam.vue?vue&type=script&lang=js"
export * from "./SorteosParam.vue?vue&type=script&lang=js"
import style0 from "./SorteosParam.vue?vue&type=style&index=0&id=61085e3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61085e3a",
  null
  
)

export default component.exports